<template>
    <div class="job-dismiss">
        <div class="modal-mask-v" v-if="job!==null">
            <div class="modal-wrapper-v">
                <div class="modal-container-v">
                    <div v-if="disclosedSuccess" class="alert alert-success">
                        {{'The job has been disclosed'|trans }}<br>
                        <RouterLink to="jobs" class="btn btn-primary">
                            <span class="title">{{'Show Jobs'|trans}}</span>
                        </RouterLink>
                    </div>
                    <div v-if="job.disclosed" class="alert alert-success">
                        {{'This job is already disclosed'|trans }}<br>
                        <RouterLink to="jobs" class="btn btn-primary">
                            <span class="title">{{'Show Jobs'|trans}}</span>
                        </RouterLink>
                    </div>
                    <div class="modal-body-v alert-danger alert" v-else>
                        <p>
                            {{'Disclose job message'|trans}}
                        </p>
                    </div>
                    <div class="modal-footer-v">
                        <slot name="footer">
                            <button v-if="job.disclosed!==true" class="pull-right spacer btn btn-primary" @click="discloseJob" >{{'Confirm'|trans}}</button>
                            <button class="pull-right spacer btn btn-default" @click="closeModal">{{'Cancel'|trans}}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            job: Object
        },
        data(){
			return {
				disclosedSuccess:false
			}
        },
        created() {

		},
		methods:{
			async discloseJob(){
				await this.$api.job.discloseJob(this.job.id);
				this.disclosedSuccess = true;
				document.body.style.position = "inherit";
			},
			closeModal(){
				this.$emit('closeModal')
			}
        },
    }
</script>

<style scoped>

    .job-dismiss{
        /*position: relative;*/
    }

    .tooltip-dismiss{
        position: absolute;
        top:18px;
        left:-10px;
        background-color: #a1be3d;
        border-radius: 4px;
        padding:10px;
    }

    .modal-mask-v {
        position: fixed;
        z-index: 999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 106%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
    }

    .modal-wrapper-v {
        display: table-cell;
        vertical-align: middle;
        height: 50%;
        width: auto;
        /*position:fixed;*/
        background-color: #e5ecee;
        padding:15% 3px;
        margin: 0px;
        color:black;

    }

    .modal-container-v {
        background-color: #fff;
        height: auto;
        overflow: scroll;
        padding:10px;
        width: 80%;
        border-radius: 8px;
        margin: 0 auto;
        -webkit-overflow-scrolling: touch;
        -webkit-box-shadow: 10px 10px 51px -13px rgba(0,0,0,0.75);
        -moz-box-shadow: 10px 10px 51px -13px rgba(0,0,0,0.75);
        box-shadow: 10px 10px 51px -13px rgba(0,0,0,0.75);
    }

    .modal-header-v {
        margin-top: 0;
        color: #42b983;
        border: 0px;
    }

    .modal-body-v {
        margin: 0;
        /*float: left;*/
        /*padding:0px;*/
        margin-top:20px;
    }

    .spacer{
        margin-left: 10px;
    }

    .modal-enter-v .modal-container-v,
    .modal-leave-active-v .modal-container-v {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }


</style>
